import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../../shared/headers/KonfiguracjaHeader";
import ReactNotify from 'react-notify';
import PojazdyService from "../../pojazdy/PojazdyService";
import PolaczenieEkipIPojazdowService from "../polaczenieEkipIPojazdow/PolaczenieEkipIPojazdowService";
import KierowcyService from "../../kierowcy/KierowcyService";
import EkipyKierowcyService from "../polaczenieEkipy/EkipyKierowcyService";
import EkipyService from "./EkipyService";
import EkipyTable from "./components/EkipyTable";
import EkipyForm from "./components/EkipyForm";
import ScrollUtilities from "../../../../../utilities/ScrollUtilities";


export default class DefinicjaEkipyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ekipy: [],
            pojazdy: [],
            kierowcy: [],
            pojazdyWekipach: [],
            kierowcyWekipach: [],

            pokazFormularz: false,
            ekipa:null,
        };
        this.zamknijFormularz = this.zamknijFormularz.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
    }

    componentDidMount() {
        this.pobierzPojazdy();
        this.pobierzKierowcow();
        this.pobierzEkipy();
    }

    pobierzPojazdy() {
        PojazdyService.getPojazdy().then(function (response) {
            let arr = Array.from(response.data.content, item => {
                return {
                    idPo: item.idPo,
                    marka: item.marka,
                    model: item.model,
                    nrRej: item.nrRej,
                    pojazdInfo: item.marka + ' ' + item.model + ' ' + item.nrRej,
                    wifi: item.wifi,
                }
            })
            this.setState({pojazdy: arr})
            this.pobierzPojazdyWEkipach(arr)
        }.bind(this))
    }

    pobierzPojazdyWEkipach(pojazdy) {
        PolaczenieEkipIPojazdowService.getEkipaPoj().then(function (response) {
            let arr = Array.from(response.data, item => {
                let pojazd = pojazdy.find(p => p.idPo === item.idPo)
                if (Boolean(pojazd)) {
                    return {
                        idEkp:item.idEkp,
                        idEk: item.idEk,
                        zmiana:item.zmiana,
                        idPo: item.idPo,
                        marka: pojazd.marka,
                        model: pojazd.model,
                        nrRej: pojazd.nrRej,
                        pojazdInfo: pojazd.marka + ' ' + pojazd.model + ' ' + pojazd.nrRej,
                        wifi: pojazd.wifi,
                    }
                }
            })
            this.setState({pojazdyWekipach:arr})
        }.bind(this))
    }

    pobierzKierowcow(){
        KierowcyService.getKierowcy().then(function (response) {
            let arr = Array.from(response.data,item=>{
                return{
                    ...item,
                    kierowcaInfo: item.imie+' '+item.nazwisko+' '+item.pesel
                }
            })
            this.setState({kierowcy:arr})
            this.pobierzKierowcowWEkipach(arr)
        }.bind(this))
    }

    pobierzKierowcowWEkipach(kierowcy){
        EkipyKierowcyService.getEkipaKier().then(function (response) {
            let arr = Array.from(response.data, item => {
                let kierowca = kierowcy.find(p => p.idKi === item.idKi)
                if (Boolean(kierowca)) {
                    return {
                        idEkk:item.idEkk,
                        idEk: item.idEk,
                        zmiana:item.zmiana,
                        idKi:item.idKi,
                        imie: kierowca.imie,
                        nazwisko: kierowca.nazwisko,
                        pesel:kierowca.pesel,
                        nrTel:kierowca.nrTel,
                        kierowcaInfo: kierowca.imie+' '+kierowca.nazwisko+' '+kierowca.pesel

                    }
                }
            })
            this.setState({kierowcyWekipach:arr})
        }.bind(this))
    }

    pobierzEkipy(){
        EkipyService.getEkipy().then(function(response) {
            this.setState({ekipy:response.data.content})
        }.bind(this))
    }

    zamknijFormularz() {
        this.setState({ekipa:null,pokazFormularz:false})
    }

    onClickEdytuj(obj) {
        this.setState({ekipa:obj,pokazFormularz:true})
        ScrollUtilities.scrollToTop()
    }

    onClickUsun(obj) {
         if (window.confirm('Czy usunąc ekipę: ' + obj.kodEk + ' ' + obj.nazwaEk)) {
             EkipyService.deleteEkipa(obj.idEk).then(function (response) {
                 if (response.status < 300) {
                     this.refs.notificator.success('Pomyślnie usunięto ekipę', "", 3000)
                     this.pobierzEkipy(this.state.pojazdy);
                 }
                 else {
                     this.refs.notificator.error('Wystąpił błąd podczas usuwania ekipy', "", 3000)
                 }
             }.bind(this))

         }
    }

    onClickZapisz(obj, czyEdycja) {
         if (czyEdycja) {
             EkipyService.editEkipa(this.state.ekipa.idEk, obj).then(function (response) {
                 if (response.status < 300) {
                     this.refs.notificator.success('Pomyślnie edytowano ekipę', "", 3000)
                     this.pobierzEkipy();
                 }
                 else {
                     this.refs.notificator.error('Wystąpił błąd podczas edycji ekipy', "", 3000)
                 }
             }.bind(this))
         }
         else {
             EkipyService.addEkipa(obj).then(function (response) {
                 if (response.status < 300) {
                     this.refs.notificator.success('Pomyślnie dodano ekipę', "", 3000)
                     this.pobierzEkipy();
                 }
                 else {
                     this.refs.notificator.error('Wystąpił błąd podczas dodawania ekipy', "", 3000)
                 }
             }.bind(this))
         }

         this.zamknijFormularz();

    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={12}>
                        <TopIf isTrue={!Boolean(this.state.pokazFormularz)}>
                            <KonfiguracjaHeader pokazFormularz={() => {
                                this.setState({pokazFormularz: true});
                                ScrollUtilities.scrollToTop()
                            }}
                                                tekstDodaj={'Dodaj definicję ekipy'}
                                                pokazButtonSzukaj={false}
                            />
                        </TopIf>
                        <TopIf isTrue={Boolean(this.state.pokazFormularz)}>
                            <EkipyForm
                                handleClickZapisz={this.onClickZapisz}
                                handleClickAnuluj={this.zamknijFormularz}
                                ekipa={this.state.ekipa}
                            />
                        </TopIf>
                        <EkipyTable     data={this.state.ekipy}
                                        pojazdyWekipach={this.state.pojazdyWekipach}
                                        kierowcyWekipach={this.state.kierowcyWekipach}
                                        handleEdytuj={this.onClickEdytuj}
                                        handleUsun={this.onClickUsun}
                                        wlaczSzukanie={true}
                            />
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/definicjaEkipy/DefinicjaEkipyContainer.js